export default __webpack_public_path__ + "static/cookies-e9daa68be8814f557ce7806ce0891397.svg";